"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaProcessEnv = exports.AlgoliaConfig = void 0;
exports.loadAlgoliaConfigFromEnv = loadAlgoliaConfigFromEnv;
exports.loadAlgoliaConfigFromFirebase = loadAlgoliaConfigFromFirebase;
const zod_1 = require("zod");
exports.AlgoliaConfig = zod_1.z.object({
    api_key: zod_1.z.string(),
    admin_key: zod_1.z.string(),
    app_id: zod_1.z.string(),
});
exports.AlgoliaProcessEnv = zod_1.z.object({
    ALGOLIA_API_KEY: zod_1.z.string(),
    ALGOLIA_ADMIN_KEY: zod_1.z.string(),
    ALGOLIA_APP_ID: zod_1.z.string(),
});
function loadAlgoliaConfigFromEnv(processEnv = process.env) {
    const config = exports.AlgoliaProcessEnv.parse(processEnv);
    return {
        api_key: config.ALGOLIA_API_KEY,
        admin_key: config.ALGOLIA_ADMIN_KEY,
        app_id: config.ALGOLIA_APP_ID,
    };
}
/**
 * @deprecated Must be replaced by end of 2025 - Google is shutting down Firebase Config
 */
function loadAlgoliaConfigFromFirebase(firestoreConfig) {
    return zod_1.z.object({ algolia: exports.AlgoliaConfig }).parse(firestoreConfig).algolia;
}
//# sourceMappingURL=config.js.map